export default __webpack_public_path__ + "static/889a7d86-12c6-408b-8c48-373a9e30545d-3eb8899a5a82acfa729973e6352babb9.woff";